import { render } from "./IconWindow.vue.js?vue&type=template&id=0517708e!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconWindow.vue?vue&type=template&id=0517708e"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__